import React from 'react';
import moment from 'moment';
import type { IReport } from './UserStatistic';
import ProgressBar from '@ramonak/react-progress-bar';
import styled from 'styled-components';
import { toHoursAndMinutes } from '../../../utils/time';

const Empty = styled.div`
  color: #999;
  padding: 20px 5px;
  text-align: center;
  width: 100%;
`;

const Days = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
  margin-right: -10px;
  color: #2b405b;
`;

const Day = styled.div`
  border: 1px solid #999;
  margin: 10px;
  text-align: center;
  padding: 10px;
  cursor: pointer;
  transition: 0.3s ease-in-out;
  &:hover {
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.5);
  }
`;

const Header = styled.div`
  font-weight: bold;
`;

const Body = styled.div`
  margin: 10px 0;
  overflow: hidden;
  span {
    display: none !important;
  }
`;

const Footer = styled.div``;

const MonthStatistic: React.FC<{
  daysStatistic: IReport[];
  month: number;
  year: number;
  setDay: (day: number) => void;
}> = (props) => {
  const workDaySeconds = 28800;

  return (
    <Days>
      {!!props.daysStatistic?.length ? (
        props.daysStatistic.map((day) => {
          const totalSeconds = day.tasks.reduce((prev, cur) => {
            return prev + cur.seconds;
          }, 0);

          const date = new Date(props.year, props.month, Number(day.day)).getTime();

          return (
            <Day key={day.day} onClick={() => props.setDay(date)}>
              <Header>{moment(date).format('Do MMMM')}</Header>
              <Body>
                <ProgressBar
                  completed={`${totalSeconds}`}
                  customLabel=""
                  maxCompleted={workDaySeconds}
                  borderRadius="0px"
                  bgColor="green"
                />
              </Body>
              <Footer>{toHoursAndMinutes(totalSeconds)}</Footer>
            </Day>
          );
        })
      ) : (
        <Empty>Пользователь не работал в этом месяце</Empty>
      )}
    </Days>
  );
};

export default MonthStatistic;
